import { CSSProperties } from "react"

export class GlobalStyles {
    static readonly expenses = {
        container: 'max-w-[1000px] px-4 flex inline-flex flex-col justify-start self-stretch items-start fill-available'
    }
    static readonly table = {
        root: 'min-w-full divide-y outline border-0 border-border-default divide-gray-200 dark:divide-neutral-700 rounded-lg overflow-hidden',
        scroll: 'min-w-full divide-y outline border-0 border-border-default divide-gray-200 dark:divide-neutral-700 rounded-lg',
        thead: 'bg-bg-banner-dark dark:bg-neutral-800 text-text-dark-invert',
        td: 'px-1 py-3 size-px h-px whitespace-nowrap text-center text-sm font-semibold text-text-dark dark:text-text-inverted',
        firstTd: 'px-1 py-1 size-px h-px whitespace-nowrap text-center text-sm font-semibold text-text-dark dark:text-text-inverted',
        atmTd: 'px-1 py-3 size-px h-px whitespace-nowrap text-center text-sm font-semibold text-text-dark dark:text-text-inverted underline',
        noResultsTd: 'p-10 size-px h-px whitespace-nowrap text-center text-sm font-semibold text-text-dark dark:text-text-inverted bg-bg-header',
    }

    static readonly menu = {
        item: 'max-w-[175px] self-stretch px-2.5 py-2 rounded-lg flex justify-start items-center gap-3.5',
        subMenu: 'max-w-[175px] pl-14 pr-2.5 py-2 rounded-lg flex justify-start items-center gap-3.5',
    }

    static readonly DataTable = {
        table: {
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontWeight: 600,
        } as CSSProperties
    }
}
